const STATS_PV_STORAGE_KEY = 'ptc_named_stats_pv_id'
const STATS_EVENT_RETRY_MS = 250
const STATS_EVENT_TIMEOUT_MS = 8000

let memoryStatsPvId = ''

function createStatsPvId() {
	if (typeof window !== 'undefined' && window.crypto && typeof window.crypto.randomUUID === 'function') {
		return window.crypto.randomUUID()
	}

	return `spv_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`
}

export function ensureStatsPvId() {
	if (typeof window === 'undefined') {
		return memoryStatsPvId || (memoryStatsPvId = createStatsPvId())
	}

	if (window.__PTC_NAMED_STATS_PV_ID__) {
		return window.__PTC_NAMED_STATS_PV_ID__
	}

	let statsPvId = ''
	try {
		statsPvId = window.sessionStorage.getItem(STATS_PV_STORAGE_KEY) || ''
		if (!statsPvId) {
			statsPvId = createStatsPvId()
			window.sessionStorage.setItem(STATS_PV_STORAGE_KEY, statsPvId)
		}
	} catch (error) {
		statsPvId = createStatsPvId()
	}

	window.__PTC_NAMED_STATS_PV_ID__ = statsPvId
	return statsPvId
}

export function createStatsExtra(statsPvId = ensureStatsPvId(), extraParams = {}) {
	return {
		v: 1,
		stats_pv_id: statsPvId,
		...extraParams,
	}
}

export function withStatsPvId(params = {}) {
	return {
		stats_pv_id: params.stats_pv_id || ensureStatsPvId(),
		...params,
	}
}

export function reportAndroidStatsEvent(eventName, url, extraParams, options = {}) {
	if (typeof window === 'undefined') return false

	const startedAt = options.startedAt || Date.now()
	const bridge = window.JSCallAndroid
	const fn = bridge && bridge.statsEvent
	const extra = typeof extraParams === 'string' ? extraParams : JSON.stringify(extraParams || createStatsExtra())

	if (typeof fn === 'function') {
		try {
			fn.call(bridge, eventName, url || window.location.href, extra)
			return true
		} catch (error) {
			console.warn('[statsEvent] Android bridge failed', error)
		}
	}

	if (Date.now() - startedAt < STATS_EVENT_TIMEOUT_MS) {
		window.setTimeout(() => {
			reportAndroidStatsEvent(eventName, url, extra, { startedAt })
		}, STATS_EVENT_RETRY_MS)
	}

	return false
}
